type ActiveFlags = {
  [variation: string]: string;
  flagKey: string;
  variationA: string;
  variationB: string;
};

export const saBanner: ActiveFlags = {
  flagKey: 'sa-banner',
  variationA: 'Control',
  variationB: 'Without',
};
